import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Checkbox, Modal } from "antd";
import { FaUpload } from "react-icons/fa";
import { MdDelete, MdCancel, MdEdit } from "react-icons/md";
import { Api_Url } from "../../../config/config";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

function PdAssestSInglePage() {
  const location = useLocation();
  const { state } = location;

  const [buisnessPdId, setBuisnessPdId] = useState("");
  const [assets, setAssets] = useState([]);
  const [formExpenseData, setFormExpenseData] = useState({
    Name: "",
    IsProof: false,
    Year: 0,
    Cost: 0,
    ImageUrl: null,
    Latitude: "",
    Longitude: "",
    BusinessPdId: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    setBuisnessPdId(state?.CustomerData?.id || "");
  }, [state]);

  useEffect(() => {
    if (buisnessPdId) {
      setFormExpenseData((prev) => ({
        ...prev,
        BusinessPdProfileId: buisnessPdId,
      }));
      fetchExpenseData();
    }
  }, [buisnessPdId]);

  const handleImageChange = (event) => {
    setFormExpenseData((prev) => ({
      ...prev,
      ImageUrl: event.target.files[0],
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    fetchCurentLocation();

    const formData = new FormData();
    formData.append("Name", formExpenseData.Name);
    formData.append("IsProof", formExpenseData.IsProof);
    formData.append("Year", formExpenseData.Year);
    formData.append("Cost", formExpenseData.Cost);
    formData.append("ImageUrl", formExpenseData.ImageUrl);
    formData.append("Latitude", formExpenseData.Latitude);
    formData.append("Longitude", formExpenseData.Longitude);
    formData.append("BusinessPdId", buisnessPdId);

    try {
      const response = await axios.post(Api_Url + "api/v1/PdAsset", formData, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
            "Content-Type": "multipart/form-data",
        },
      });
      console.log(response?.data?.succeeded);
      if (response?.data?.succeeded) {
        SuccessToast("Added successfully");
        fetchExpenseData();
        setIsModalOpen(false);
        setFormExpenseData({
          Name: "",
          IsProof: false,
          Year: 0,
          Cost: 0,
          ImageUrl: null,
          Latitude: "",
          Longitude: "",
          BusinessPdProfileId: buisnessPdId,
        });
      }
    } catch (error) {
      console.error("Error adding asset:", error);
    }
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (itemToDelete) {
      try {
        await axios.delete(Api_Url + "api/v1/PdAsset/" + itemToDelete, {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        });
        fetchExpenseData();
        setIsDeleteModalOpen(false);
        setItemToDelete(null);
      } catch (error) {
        console.error("Error deleting asset:", error);
      }
    }
  };

  const fetchExpenseData = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + `api/v1/PdAsset/getby-pd-profileid/${buisnessPdId}`,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      setAssets(data.data);
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setFormExpenseData((prev) => ({
          ...prev,
          Latitude: latitude,
          Longitude: longitude,
        }));
      });
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    fetchCurentLocation();
  }, []);

  const [editFormData, setEditFormData] = useState({
    id: 0,
    name: "",
    cost: 0,
    year: 0,
    imageUrl: null,
    isProof: "",
    latitude: "",
    longitude: "",
  });

  const handleEditImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setEditFormData((prev) => ({
        ...prev,
        imageUrl: file,
      }));
    }
  };

  const Location = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setEditFormData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  const handleShowDetail = async (id) => {
    console.log(id);
    try {
      const response = await axios.get(`${Api_Url}api/v1/PdAsset/${id}`, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      });
      console.log(response?.data?.data);
      setEditFormData(response?.data?.data);
      setIsEditModalOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdate = async (id) => {
    Location()
    const formData = new FormData();
    formData.append("Id", editFormData?.id);
    formData.append("Name", editFormData?.name);
    formData.append("Cost", editFormData?.cost);
    if (editFormData.imageUrl) {
      formData.append("ImageUrl", editFormData.imageUrl); // Only append the ImageUrl if a new file is selected
    }
    formData.append("IsProof", editFormData?.isProof);
    formData.append("Year", editFormData?.year);
    formData.append("Latitude", editFormData?.latitude);
    formData.append("Longitude", editFormData?.longitude);

    console.log("kkk", id);
    try {
      const response = await axios.put(
        `${Api_Url}api/v1/PdAsset/${id}`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("updated", response.data);
      if (response.data?.succeeded) {
        SuccessToast("Updated Successfully");
        fetchExpenseData();
        setIsEditModalOpen(false);
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error;
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content conatainer-fluid">
        <div className="container mt-3">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-end">
              <button
                className="btn btn-primary submit-btn"
                onClick={() => setIsModalOpen(true)}
              >
                Add Asset
              </button>
            </div>
          </div>

          <div className="row mt-4">
            {assets.length > 0 &&
              assets.map((item) => (
                <div
                  key={item.id}
                  className="col-lg-4 col-md-6 col-sm-12 col-12"
                >
                  <div className="card py-4 px-3">
                    <div className="checkpoint-image-container w-100">
                      <img
                        className="w-100 rounded"
                        src={item?.imageUrl}
                        alt="CheckpointImage"
                        style={{ height: "230px" }}
                      />
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <h6 className="">Name: </h6>
                      <p>{item?.name}</p>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <h6 className="">Year: </h6>
                      <p>{item?.year || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <h6 className="">Cost: </h6>
                      <p>{item?.cost || "N/A"}</p>
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                      <div className="d-flex align-items-center justify-content-end gap-1">
                        <MdEdit
                          cursor="pointer"
                          size={28}
                          onClick={() => handleShowDetail(item.id)}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-end gap-1">
                        <MdDelete
                          cursor={"pointer"}
                          size={28}
                          onClick={() => handleDeleteClick(item.id)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* Add Expense Modal */}
          <Modal
            title={<span className="fs-5 fw-bold">Add Asset</span>}
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            footer={[
              <button
                key="submit"
                className="btn btn-primary submit-btn"
                type="submit"
                onClick={handleSubmit}
              >
                Submit
              </button>,
            ]}
            width={600}
            mask={false}
            maskClosable={false}
            closeIcon={<span style={{ color: "red" }}>X</span>}
          >
            <div className="modal-body mt-3">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Asset Name</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Asset Name"
                        value={formExpenseData.Name}
                        onChange={(event) =>
                          setFormExpenseData({
                            ...formExpenseData,
                            Name: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Asset Price</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="Enter Asset Price"
                        value={formExpenseData.Cost}
                        onChange={(event) =>
                          setFormExpenseData({
                            ...formExpenseData,
                            Cost: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Year</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="Enter Year"
                        value={formExpenseData.Year}
                        onChange={(event) =>
                          setFormExpenseData({
                            ...formExpenseData,
                            Year: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                  <input
                  type="file"
                  accept="image/*"
                  name=""
                  id="upload-image"
                  onChange={handleImageChange}
                />
                    {/* {formExpenseData.ImageUrl !== null ? (
                      <p className="mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                        {formExpenseData?.ImageUrl?.name}{" "}
                        <MdCancel
                          size={20}
                          onClick={() =>
                            setFormExpenseData((prev) => ({
                              ...prev,
                              ImageUrl: null,
                            }))
                          }
                        />
                      </p>
                    ) : (
                      <label htmlFor="upload-image" className="">
                        <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                          <FaUpload size={20} /> Click to Upload
                        </p>
                      </label>
                    )} */}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="input-block mb-3 d-flex align-items-center gap-1">
                      <Checkbox
                        onChange={(e) =>
                          setFormExpenseData({
                            ...formExpenseData,
                            IsProof: e.target.checked,
                          })
                        }
                      />
                      <p>Check as Proof</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>

          {/* Edit Singleuser Modal */}

          <Modal
            title={<span className="fs-5 fw-bold">Edit Asset</span>}
            open={isEditModalOpen}
            onOk={() => setIsEditModalOpen(false)}
            onCancel={() => setIsEditModalOpen(false)}
            footer={[
              <button
                key="submit"
                className="btn btn-primary submit-btn"
                type="submit"
                onClick={() => handleUpdate(editFormData?.id)}
              >
                Submit
              </button>,
            ]}
            width={600}
            mask={false}
            maskClosable={false}
            closeIcon={<span style={{ color: "red" }}>X</span>}
          >
            <div className="modal-body mt-3">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Asset Name</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Asset Name"
                        value={editFormData.name}
                        onChange={(event) =>
                          setEditFormData({
                            ...editFormData,
                            name: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Asset Price</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="Enter Asset Price"
                        value={editFormData.cost}
                        onChange={(event) =>
                          setEditFormData({
                            ...editFormData,
                            cost: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Year</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="Enter Year"
                        value={editFormData.year}
                        onChange={(event) =>
                          setEditFormData({
                            ...editFormData,
                            year: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
              <div className="col-sm-12">
                <input
                  type="file"
                  accept="image/*"
                  name=""
                  id="upload-image"
                  onChange={handleEditImageChange}
                  hidden
                />
                {editFormData?.imageUrl || editFormData.imageUrl !== null ? (
                  <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                    {editFormData?.imageUrl?.name}{" "}
                    <MdCancel
                      size={20}
                      onClick={() =>
                        setEditFormData((prev) => ({
                          ...prev,
                          imageUrl: null,
                        }))
                      }
                    />
                  </p>
                ) : (
                  <label htmlFor="upload-image" className="">
                    <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                      <FaUpload size={20} /> Click to Upload
                    </p>
                  </label>
                )}
              </div>
            </div>
                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="input-block mb-3 d-flex align-items-center gap-1">
                      <Checkbox
                        checked={editFormData.isProof}
                        onChange={(e) =>
                          setEditFormData({
                            ...editFormData,
                            isProof: e.target.checked,
                          })
                        }
                      />
                      <p>Check as Proof</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>

          {/* SingleUser */}

          {/* Delete Confirmation Modal */}
          <Modal
            title="Confirm Delete"
            visible={isDeleteModalOpen}
            onOk={confirmDelete}
            onCancel={() => setIsDeleteModalOpen(false)}
            okText="Delete"
            cancelText="Cancel"
            maskClosable={false}
            closeIcon={<MdCancel />}
            width={400}
          >
            <p>Are you sure you want to delete this asset?</p>
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default PdAssestSInglePage;

// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { Checkbox, Modal } from "antd";
// import { FaUpload } from "react-icons/fa";
// import { MdDelete, MdCancel } from "react-icons/md";
// import { Api_Url } from "../../../config/config";
// import { SuccessToast } from "../../ToastComponent";

// function PdAssestSInglePage() {
//   const location = useLocation();
//   const { state } = location;

//   const [buisnessPdId, setBuisnessPdId] = useState("");
//   const [assets, setAssets] = useState([]);
//   const [formExpenseData, setFormExpenseData] = useState({
//     Name: "",
//     IsProof: false,
//     Year: 0,
//     Cost: 0,
//     ImageUrl: null,
//     Latitude: "",
//     Longitude: "",
//     BusinessPdId: "",
//   });
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     setBuisnessPdId(state?.CustomerData?.id || "");
//   }, [state]);

//   useEffect(() => {
//     if (buisnessPdId) {
//       setFormExpenseData((prev) => ({
//         ...prev,
//         BusinessPdProfileId: buisnessPdId,
//       }));
//       fetchExpenseData();
//     }
//   }, [buisnessPdId]);

//   const handleImageChange = (event) => {
//     setFormExpenseData({
//       ...formExpenseData,
//       ImageUrl: event.target.files[0],
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     fetchCurentLocation();

//     const formData = new FormData();
//     formData.append("Name", formExpenseData.Name);
//     formData.append("IsProof", formExpenseData.IsProof);
//     formData.append("Year", formExpenseData.Year);
//     formData.append("Cost", formExpenseData.Cost);
//     formData.append("ImageUrl", formExpenseData.ImageUrl);
//     formData.append("Latitude", formExpenseData.Latitude);
//     formData.append("Longitude", formExpenseData.Longitude);
//     formData.append("BusinessPdId", buisnessPdId);

//     try {
//       const response= await axios.post(
//         Api_Url + "api/v1/PdAsset",
//         formData,
//         {
//           headers: {
//             Authorization:
//               "Bearer " +
//               JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//           },
//         }
//       );
//       console.log(response?.data?.succeeded)
//       if (response?.data?.succeeded) {
//         SuccessToast("Added successfully")
//         fetchExpenseData();
//         setIsModalOpen(false);
//         setFormExpenseData({
//           Name: "",
//           IsProof: false,
//           Year: 0,
//           Cost: 0,
//           ImageUrl: null,
//           Latitude: "",
//           Longitude: "",
//           BusinessPdProfileId: buisnessPdId,
//         });
//       }
//     } catch (error) {
//       console.error("Error adding asset:", error);
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(Api_Url + "api/v1/PdAsset/" + id, {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//         },
//       });
//       fetchExpenseData();
//     } catch (error) {
//       console.error("Error deleting asset:", error);
//     }
//   };

//   const fetchExpenseData = async () => {
//     try {
//       const { data } = await axios.get(
//         Api_Url + `api/v1/PdAsset/getby-pd-profileid/${buisnessPdId}`,
//         {
//           headers: {
//             Authorization:
//               "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//           },
//         }
//       );
//       setAssets(data.data);
//     } catch (error) {
//       console.error("Error fetching assets:", error);
//     }
//   };

//   const fetchCurentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition((position) => {
//         const { latitude, longitude } = position.coords;
//         setFormExpenseData((prev) => ({
//           ...prev,
//           Latitude: latitude,
//           Longitude: longitude,
//         }));
//       });
//     } else {
//       console.error("Geolocation is not supported by this browser.");
//     }
//   };

//   useEffect(() => {
//     fetchCurentLocation();
//   }, []);

//   return (
//     <div className="page-wrapper">
//       <div className="content conatainer-fluid">
//         <div className="container mt-3">
//           <div className="row">
//             <div className="col-12 d-flex align-items-center justify-content-end">
//               <button
//                 className="btn btn-primary submit-btn"
//                 onClick={() => setIsModalOpen(true)}
//               >
//                 Add Asset
//               </button>
//             </div>
//           </div>

//           <div className="row mt-4">
//             {assets.length > 0 &&
//               assets.map((item) => (
//                 <div key={item.id} className="col-lg-4 col-md-6 col-sm-12 col-12">
//                   <div className="card py-4 px-3">
//                     <div className="checkpoint-image-container w-100">
//                       <img
//                         className="w-100 rounded"
//                         src={item?.imageUrl}
//                         alt="CheckpointImage"
//                         style={{ height: "230px" }}
//                       />
//                     </div>
//                     <div className="d-flex align-items-center gap-1">
//                       <h6 className="">Name: </h6>
//                       <p>{item?.name}</p>
//                     </div>
//                     <div className="d-flex align-items-center gap-1">
//                       <h6 className="">Year: </h6>
//                       <p>{item?.year || "N/A"}</p>
//                     </div>
//                     <div className="d-flex align-items-center gap-1">
//                       <h6 className="">Cost: </h6>
//                       <p>{item?.cost || "N/A"}</p>
//                     </div>
//                     <div className="d-flex align-items-center justify-content-end gap-1">
//                       <MdDelete
//                         cursor={"pointer"}
//                         size={28}
//                         onClick={() => handleDelete(item.id)}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               ))}
//           </div>

//           {/* Add Expense Modal */}
//           <Modal
//             title={<span className="fs-5 fw-bold">Add Asset</span>}
//             open={isModalOpen}
//             onOk={() => setIsModalOpen(false)}
//             onCancel={() => setIsModalOpen(false)}
//             footer={[
//               <button
//                 key="submit"
//                 className="btn btn-primary submit-btn"
//                 type="submit"
//                 onClick={handleSubmit}
//               >
//                 Submit
//               </button>,
//             ]}
//             width={600}
//             mask={false}
//             maskClosable={false}
//             closeIcon={<span style={{ color: "red" }}>X</span>}
//           >
//             <div className="modal-body mt-3">
//               <form>
//                 <div className="row">
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Asset Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         placeholder="Enter Asset Name"
//                         value={formExpenseData.Name}
//                         onChange={(event) =>
//                           setFormExpenseData({
//                             ...formExpenseData,
//                             Name: event.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Asset Price</label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         placeholder="Enter Asset Price"
//                         value={formExpenseData.Cost}
//                         onChange={(event) =>
//                           setFormExpenseData({
//                             ...formExpenseData,
//                             Cost: event.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-sm-12">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Asset Year</label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         placeholder="Enter Asset Year"
//                         value={formExpenseData.Year}
//                         onChange={(event) =>
//                           setFormExpenseData({
//                             ...formExpenseData,
//                             Year: event.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-sm-12">
//                     <input
//                       type="file"
//                       name=""
//                       id="upload-image"
//                       onChange={handleImageChange}
//                       hidden
//                       accept="image/*"
//                     />
//                     {formExpenseData.ImageUrl !== null ? (
//                       <p className="mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                         {formExpenseData?.ImageUrl?.name}{" "}
//                         <MdCancel
//                           size={20}
//                           onClick={() =>
//                             setFormExpenseData((prev) => ({
//                               ...prev,
//                               ImageUrl: null,
//                             }))
//                           }
//                         />
//                       </p>
//                     ) : (
//                       <label htmlFor="upload-image" className="">
//                         <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                           <FaUpload size={20} /> Click to Upload
//                         </p>
//                       </label>
//                     )}
//                   </div>
//                 </div>
//                 <div className="row mt-2">
//                   <div className="col-sm-12">
//                     <Checkbox
//                       checked={formExpenseData.IsProof}
//                       onChange={(event) =>
//                         setFormExpenseData({
//                           ...formExpenseData,
//                           IsProof: event.target.checked,
//                         })
//                       }
//                     >
//                       Have Proof Available
//                     </Checkbox>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </Modal>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default PdAssestSInglePage;
